import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import '../App.css';

const Experiences = ({ t }) => {
  return (
    <section id="experiences" className="section-spacing">
      <motion.h2 
        className="section-heading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      >
        {t.experiencesTitle}
      </motion.h2>

      <div className="experiences-container">
        {t.experiences.map((exp, index) => (
          <motion.div 
            key={index} 
            className="bento-card experience-card glass-panel"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: index * 0.15, ease: [0.4, 0, 0.2, 1] }}
            whileHover={{ scale: 1.01, y: -4, transition: { duration: 0.3 } }}
          >
            <div className="experience-header">
              <div className="experience-title-group">
                <h3 className="experience-title">{exp.title}</h3>
                <h4 className="experience-company">{exp.company}</h4>
              </div>
              <div className="experience-date-badge">{exp.date}</div>
            </div>
            
            <ul className="experience-details">
              {exp.details.map((detail, i) => {
                const isLink = detail.includes("http");
                return (
                  <li key={i}>
                    <CheckCircle className="check-icon" size={20} />
                    <span>
                      {isLink ? (
                        <>
                          {detail.split(/(https:\/\/[^\s)]+)/).map((part, j) => 
                            part.startsWith("http") ? 
                            <a key={j} href={part} target="_blank" rel="noopener noreferrer" className="inline-link">{part}</a> : 
                            part
                          )}
                        </>
                      ) : detail}
                    </span>
                  </li>
                )
              })}
            </ul>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Experiences;
